import { render } from "./numberedList.vue?vue&type=template&id=7d4dd9ea"
import script from "./numberedList.vue?vue&type=script&lang=js"
export * from "./numberedList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__